import React, {useEffect, useState} from 'react'
import Select from "react-select";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Col, Form, FormGroup, Input, Row, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";

// components
import { ButtonCancel, ButtonSubmit } from "../../buttons/buttonsActions";

// labels
import {
    LB_ADULTS, LB_COMMENTS, LB_DATE, LB_HOUR, LB_INFANTS,
    LB_PEOPLE, LB_REMINDER, LB_ROOM_CHARGE, LB_YOUNGER, REQUIRED
} from "../../i18n/i18n";

// actions
import { add } from "../../../redux/actions/todoFluye/wishlistActions";

// utils
import {formatStringDate} from "../../../util/DateTools";

// providers
import { udnProvider } from "../../../providers/udnProvider";
import { afiPickupScheduleProvider } from "../../../providers/afiPickupScheduleProvider";
import { wishlistTypes } from "../../../util/WishlistUtils";
import Switch from "react-bootstrap-switch";

const ParkFormComponent = props => {
    const fbDataBaseId = props.mainState?.app?.fbDataBase?.id
    const udn =  JSON.parse( localStorage.getItem('selectedUdn') )

    const { domainObject } = props.formState
    const { wishlist, handleCancel, handleToggle  } = props

    const [ editMode ] = useState(domainObject != null)

    const [parks, setParks] = useState([])
    const [park, setPark] = useState()
    const [loadingParks, setLoadingParks] = useState(true)
    const [parkError, setParkError] = useState(false)
    const [loadedDefaultPark, setLoadedDefaultPark] = useState(false)


    const [schedules, setSchedules] = useState([])
    const [schedule, setSchedule] = useState()
    const [loadingSchedules, setLoadingSchedules] = useState(true)
    const [scheduleError, setScheduleError] = useState(false)
    const [loadedDefaultSchedule, setLoadedDefaultSchedule] = useState(false)

    const [pax, setPax] = useState(domainObject?.pax || 0)
    const [paxError, setPaxError] = useState(false)

    const [roomCharge, setRoomCharge] = useState(domainObject?.roomCharge || false)
    const [adults, setAdults] = useState(domainObject?.adults || 0)
    const [childs, setChilds] = useState(domainObject?.childs || 0)
    const [infants, setInfants] = useState(domainObject?.infants || 0)

    const [ reminder, setReminder ] = useState( domainObject?.reminder || false )



    // Load Parks
    useEffect(()=> {
        const requestData = { afiClass:{ code:'xxx'} }

        setLoadingParks(true)

        udnProvider.getOptionsByCustomFilter( requestData )
            .then( setParks )
            .finally(() => setLoadingParks(false) )
    },[])

    // Load schedules
    useEffect(()=> {
        setSchedule(null)

        if(!park){
            setSchedules([])
            setLoadingSchedules( false )
            return
        }

        setParkError(false)

        const dataRequest = {
            udnFrom: { id: udn?.id },
            udnTo: { id: park?.id }
        }

        setLoadingSchedules(true)

        afiPickupScheduleProvider.getOptions( dataRequest )
            .then( setSchedules )
            .finally( ()=> setLoadingSchedules(false))
    },[park])

    // load default data
    useEffect(()=>{
        if(!domainObject)
            return

        if(!loadedDefaultPark && parks.length > 0){
            const defaultPlace = parks.find( i => i.id === domainObject?.udn?.id)
            setPark(defaultPlace)
            setLoadedDefaultPark(true)
        }

        if(!loadedDefaultSchedule && schedules.length > 0){
            const defaultSchedule = schedules.find(s => s.value === domainObject.hour)
            setSchedule(defaultSchedule)
            setLoadedDefaultSchedule(true)
        }
    },[parks, schedules])



    const validationSchema = Yup.object().shape({
        date: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues:{
            date: domainObject ? formatStringDate(domainObject?.date) : null,
            comments: domainObject?.comments,
            confirmationCode: domainObject?.confirmationCode,
        }
    });



    const onSubmit = (data, _) => {
        if(!park){
            setParkError(true)
            return
        }

        /*if(!schedule){
            setScheduleError(true)
            return;
        }*/

        if(pax <= 0){
            setPaxError(true)
            return
        }

        let dataRequest = {
            fbDataBase: fbDataBaseId,
            item: {
                ... data,
                type: wishlistTypes.afi.description,
                hour: schedule?.value,
                from:'wishlist',
                roomCharge,
                reminder,
                udn:{ id: park?.id },
                wishlist:{ id: wishlist?.id },
            }
        }

        if(domainObject)
            dataRequest.item.id = domainObject?.id

        props.add( dataRequest, handleToggle )
    }

    const onAdultsChange = e => {
        const value = parseInt(e?.target?.value || 0)
        const total = value + childs + infants

        setPaxError( total <= 0)
        setAdults( value )
        setPax( total )
    }

    const onChildsChange = e => {
        const value = parseInt( e?.target?.value || 0)
        const total = adults + value + infants

        setPaxError( total <= 0)
        setChilds( value )
        setPax( total )
    }

    const onInfantsChange = e => {
        const value = parseInt(e?.target?.value || 0)
        const total = adults + childs + value

        setPaxError( total <= 0)
        setInfants( value )
        setPax( total )
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className={'mb-1em'}>
            <Col className={'wl-modal-title-item'}>
                <img
                    src={require(`../../../assets/images/wishlist/${props?.selectedOption?.icon}`)}
                    alt={props?.selectedOption?.title}
                    width={36}
                    height={36}
                /> &nbsp; { props?.selectedOption?.title }
            </Col>
            <Col>
                <FormGroup>
                    {
                        loadingParks ?  <> <Spinner animation="border" /> </> : <Select
                            value={ park }
                            options={ parks}
                            isClearable={ true }
                            onChange={ val => {
                                setParkError(!val)
                                setPark(val)
                            } }
                            isDisabled={ editMode }
                            styles={{ }}
                        />
                    }
                    { parkError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <label>
                        <i className={ 'fa fa-calendar' } aria-hidden='true' /> &nbsp;{ LB_DATE }
                    </label>
                    <Input
                        name='date'
                        type='date'
                       /* min={ getDateToFormField(wishlist?.checkIn) }
                        max={ getDateToFormField(wishlist?.checkOut) }*/
                        innerRef={register}
                    />
                    { errors?.date && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.date?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <label>
                    <i className={ 'fa fa-clock' } aria-hidden='true' /> &nbsp;{ LB_HOUR }
                </label>
                <br/>
                {
                    loadingSchedules ?  <> <Spinner animation="border" /> </> : <Select
                        value={ schedule }
                        options={ schedules }
                        isClearable={ true }
                        onChange={ val => {
                            setScheduleError(!val)
                            setSchedule(val)
                        } }
                        styles={{ }}
                    />
                }
                { scheduleError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
            </Col>
            <Col>
                <FormGroup>
                    <label>
                        <i className={ 'fa fa-users' } aria-hidden='true' /> &nbsp;{ LB_PEOPLE }
                    </label>
                    <Input
                        name='pax'
                        type='number'
                        value={ pax }
                        readOnly={ true }
                    />
                    { paxError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <label>{ LB_ADULTS }</label>
                    <Input
                        name='adults'
                        type='number'
                        min={ 0}
                        innerRef={register}
                        onChange={ onAdultsChange }
                    />
                    { errors?.adults && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.adults?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <label>{ LB_YOUNGER }</label>
                    <Input
                        name='childs'
                        type='number'
                        min={ 0 }
                        innerRef={register}
                        onChange={ onChildsChange }
                    />
                    { errors?.childs && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.childs?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <label>{ LB_INFANTS }</label>
                    <Input
                        name='infants'
                        type='number'
                        min={ 0 }
                        innerRef={register}
                        onChange={ onInfantsChange }
                    />
                    { errors?.infants && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.infants?.message}</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col  sm={3}>
                <FormGroup>
                    <label>{ LB_ROOM_CHARGE }</label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        value={ roomCharge }
                        onChange={ () => setRoomCharge(!roomCharge) }
                    />
                </FormGroup>
            </Col>
            <Col sm={3}>
                <FormGroup>
                    <label>{ LB_REMINDER }</label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        value={ reminder }
                        onChange={ () => setReminder(!reminder) }
                    />
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <label>{ LB_COMMENTS }</label>
                <FormGroup>
                    <Input
                        name='comments'
                        type="textarea"
                        innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col className="d-flex justify-content-center">
                <div>
                    <ButtonSubmit/>
                    <ButtonCancel onClick={ ()=> handleCancel() }/>
                </div>
            </Col>
        </Row>
    </Form>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    formState: state.formProps
})
const mapActionsToProps = ({
    add
})

export default connect(mapStateToProps, mapActionsToProps)(ParkFormComponent)